<template>
    <n-card title="Tecnicos" class="p-4">
      <div class="flex justify-between mb-4">
        <n-button type="primary" @click="mostrarModalTecnico">Novo Técnico</n-button>
      </div>
  
      <n-data-table
        :columns="colunas"
        :data="tecnicos"
        :loading="carregando"
        :scroll-x="1800"
        :row-props="clickRow"
        bordered
      />
      <n-modal 
        :show="showModal" 
        :title="alteracao?`Técnico: ${cd_tecnico}`:'Novo Técnico'"
        preset="dialog" 
        style="width: 600px"
        @close="mostrarModalTecnico"
      >
        <div class="grid grid-cols-2 gap-4">
            <n-input v-model:value="nm_tecnico" placeholder="Nome" label="Nome" />
            <n-input v-model:value="nm_cpf" placeholder="CPF" label="CPF" />
            <n-input v-model:value="nm_estado" placeholder="Estado" label="Estado" />
            <n-input v-model:value="nm_email" placeholder="Email" label="Email" />
            <n-input v-model:value="nm_telefone" placeholder="Telefone" label="Telefone" />
          </div>
        
          <div class="flex justify-end mt-4 gap-2">
            <n-button @click="mostrarModalTecnico">Cancelar</n-button>
            <n-button type="primary" @click="salvarTecnico">Salvar</n-button>
          </div>
        </n-modal>
    </n-card>
</template>
<script>
import api from "@/api/api"
import { NTag, useMessage } from "naive-ui"
import { h } from 'vue'

export default{
    data(){
        const validaFunc = (row) =>{
            carregaTecnico(row)
            console.log(row)
        }
        const carregaTecnico = (tecnico) => {
            this.showModal = true
            this.alteracao = true
            this.cd_tecnico = tecnico.cd_tecnico
            this.nm_tecnico = tecnico.nm_tecnico
            this.nm_cpf = tecnico.nm_cpf
            this.nm_estado = tecnico.nm_estado
            this.nm_email = tecnico.nm_email
            this.nm_telefone = tecnico.nm_telefone
        }
        return{
            carregando: false,
            alteracao: false,
            message: useMessage(),
            cd_tecnico:null,
            nm_tecnico:null,
            nm_cpf:null,
            nm_estado:null,
            nm_email:null,
            nm_telefone:null,
            tecnicos: [],
            showModal: false,
            colunas: [
                { 
                  title: "ID do Técnico", 
                  key: "actions",
                  render(row){
                    return h(
                      NTag,
                      {
                        strong: true,
                        tertiary: true,
                        size: 'small',
                        type: 'info',
                        onClick: () => validaFunc(row)
                      },
                      {default:()=> row.cd_tecnico}
                    )
                  }
                },
                { title: "Nome", key: "nm_tecnico" },
                { title: "CPF", key: "nm_cpf" },
                { title: "Estado", key: "nm_estado" },
                { title: "Email", key: "nm_email" },
                { title: "Telefone", key: "nm_telefone" }
            ]
        }
    },
    created(){
        this.carregaTecnicos()
    },
    methods:{
        async carregaTecnicos() {
            this.carregando = true
            try{
                this.tecnicos = await api.get('tecnico')
            }
            catch(err){

            }
            this.carregando = false
        },
        mostrarModalTecnico(tecnico){
            this.showModal = !this.showModal
            if(this.showModal)this.limparCampos()
        },
        async salvarTecnico(){
            const payload = {
                nm_tecnico: this.nm_tecnico,
                nm_cpf: this.nm_cpf,
                nm_estado: this.nm_estado,
                nm_email: this.nm_email,
                nm_telefone: this.nm_telefone,
            }
            if(this.alteracao){
                await api.put('tecnico/'+this.cd_tecnico, payload)
            }
            else{
                await api.post('tecnico', payload)
            }
            this.message.success("Chamado criado com sucesso")
            this.mostrarModalTecnico()
            this.carregaTecnicos()
        },
        limparCampos(){
            this.alteracao = false
            this.cd_tecnico = null
            this.nm_tecnico = null
            this.nm_cpf = null
            this.nm_estado = null
            this.nm_email = null
            this.nm_telefone = null
        }
    }
}
</script>
<style>
/* ====== Layout geral ====== */
.p-4 {
  padding: 1.5rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
  align-items: center;
}

.gap-2 {
  gap: 0.75rem;
}

.mt-4 {
  margin-top: 1.25rem;
}

/* ====== Botões ====== */
.n-button {
  transition: all 0.2s ease-in-out;
}

.n-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* ====== Cartão principal ====== */
.n-card {
  border-radius: 16px !important;
}

/* ====== Tabela ====== */
.n-data-table {
  border-radius: 12px;
  overflow: hidden;
}

.n-data-table ::v-deep(.n-data-table-th) {
  font-weight: 600;
}

.n-data-table ::v-deep(.n-data-table-td) {
  padding: 0.8rem 1rem !important;
  font-size: 0.95rem;
}

/* ====== Modal ====== */
.n-modal {
  border-radius: 16px !important;
  padding: 1.5rem;
}

.n-modal ::v-deep(.n-dialog__title) {
  font-size: 1.3rem;
  font-weight: 600;
  color: #222;
}

/* ====== Grid do formulário ====== */
.grid {
  display: grid;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.gap-4 {
  gap: 1.25rem;
}

/* ====== Campos de entrada ====== */
.n-input,
.n-date-picker {
  width: 100%;
}

.n-input ::v-deep(input),
.n-date-picker ::v-deep(input) {
  border-radius: 10px !important;
  padding: 10px 14px !important;
}

/* ====== Botões do modal ====== */
.modal-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
  gap: 1rem;
}

/* ====== Animações sutis ====== */
.n-card,
.n-modal {
  transition: all 0.3s ease-in-out;
}

.n-modal[show="true"] {
  transform: scale(1.02);
}
</style>